<template>
    <div>
        <strong>{{ getActorName }}</strong> kullanıcısı:
        <span v-for="(assignee, index) in $_.get(activity, 'payload.assignees')" :key="index">
            <strong>{{ assignee }} </strong>,
        </span>
        <strong>"{{ $_.get(activity, "payload.taskTitle") }}"</strong> adlı göreve atadı<span v-if="ruleSource"> (<em>{{ ruleSource }}</em> aracılığıyla)</span>.
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskAssignedToUser",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        getActorName() {
            const actorName = this.$_.get(this.activity, "actorUser.name");
            if (actorName) return actorName;
            if (this.$_.get(this.activity, "actor") === "system") return "Sistem";
            return "Bilinmeyen";
        },
        ruleSource() {
            return this.$_.get(this.activity, "payload.ruleSource");
        }
    }
});
</script>

<style scoped lang="scss"></style>
